export enum PromotableType {
  ProductCategory = "ProductCategory",
  Space = "Space",
  SpaceOffering = "SpaceOffering",
}

export interface Promotable {
  id: string;
  type: string;
  name: string;
}

export const toPromotable = (data: any): Promotable => {
  return {
    id: data.id,
    type: data.type,
    name: data.name,
  };
};
